<template>
<div>
  <div @mouseenter="handleCardMouseenter" @mouseleave="handleCardMouseover">
    <van-popover :show="showCartPopover" trigger="manual">
      <template #reference>
        <slot name="title" />
      </template>
      <div class="cart-list-body"  @mouseenter="handleCardMouseenter" @mouseleave="handleCardMouseover">
        <slot></slot>
      </div>
    </van-popover>
  </div>
</div>
</template>

<script setup lang="ts">
const showCartPopover = ref<boolean>(false)

let isHoverEnter = false
const handleCardMouseenter = () => {
  showCartPopover.value = true
  isHoverEnter = true
}

const handleCardMouseover = () => {
  isHoverEnter = false

  setTimeout(() => {
    !isHoverEnter && (showCartPopover.value = false)
  }, 200)
}
</script>

<style scoped>

</style>